<template>
  <RowItemAligned
    class="row-item"
    :labels="wallboxLabels"
    :values="wallboxValues"
    :editable="true"
    last
    @edit="
      $emit('edit-component', {
        component: 'WallboxEditComponent',
        location: 'technicalDetailsComponent',
        properties: {
          wallboxData,
          deviceUuid,
        },
      })
    "
  />
</template>

<script>
import RowItemAligned from './RowItemAligned';

export default {
  name: 'WallboxSpecialData',
  props: {
    wallboxData: {
      type: Object,
      required: true,
    },
    deviceUuid: {
      type: String,
      required: true,
    },
  },
  components: {
    RowItemAligned,
  },
  computed: {
    wallboxLabels() {
      const data = this.wallboxData;
      if (!data) return ['-'];

      const labels = [];

      // Bauart
      if (data.installation_type !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.installation_type')
        );
      }

      // Art der Ladung
      if (data.charging_type) {
        labels.push(this.$t('consumption_devices.order_details.charging_type'));
      }

      // Anzahl der Ladepunkte
      if (data.charging_points !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.charging_points')
        );
      }

      // installation_location
      labels.push(
        this.$t('consumption_devices.order_details.installation_location')
      );

      return labels;
    },

    wallboxValues() {
      const data = this.wallboxData;
      if (!data) return ['-'];

      const values = [];

      // installation_type
      if (data.installation_type !== undefined) {
        values.push(
          data.installation_type === 'charging_station'
            ? 'Ladesäule'
            : 'Privater Ladepunkt für E-Mobilität'
        );
      }

      // charging_type
      if (data.charging_type) {
        values.push(
          data.charging_type === 'AC_charger' ? 'AC Lader' : 'DC Lader'
        );
      }

      // charging_points
      if (data.charging_points !== undefined) {
        values.push(data.charging_points);
      }

      // installation_location
      values.push(data.installation_location);

      return values;
    },
  },
};
</script>

<style scoped>
.row-item {
  margin-block: 1px;
}
</style>
